import { IPromise, IError, IProgress } from '../ISignatureApplet';

export class Deferred<TResult> implements IPromise<TResult> {
    protected handlers: Array<Function>[] = [];
    protected result: any;
    protected resolution: number = -1;

    then(
        done: (result: TResult) => any,
        fail?: (error: IError) => any,
        progress?: (progress: IProgress) => any
    ): any {
        this.handlers.push([done, fail, progress]);
        if (this.resolution < 0) return;
        this.handle(this.resolution);
    }

    resolve(result: TResult): void {
        this.result = result;
        this.handle(this.resolution = 0);
    }

    reject(error: IError): void {
        this.result = error;
        this.handle(this.resolution = 1);
    }

    notify(progress: IProgress): void {
        for (let i = 0; i < this.handlers.length; ++i) {
            const handler = this.handlers[i][2];
            if (handler) handler.call(null, progress);
        }
    }

    protected handle(funcIndex: number): void {
        while (this.handlers.length) {
            const handler = this.handlers.shift()[funcIndex];
            if (handler) handler.call(null, this.result);
        }
    }
}
